import { useEffect } from 'react'
import { Button, VStack } from '@chakra-ui/react'
import { REGISTER_SCHEMA_STEP_TWO, RegisterStepTwoType, useRegisterStep } from 'context/Register'
import { Formik } from 'formik'

import { InputControl, SubmitButton } from 'components/InputCustom'
import { customToast } from 'components/ToastCustom'


export const StepTwo = () => {
  const {
    clearError,
    stepTwoDispatch,
    prevStep,
    registerStepState: {
      error,
      loading,
      state: {
        registerMock: { firstName, lastName, rut },
      },
    },
  } = useRegisterStep()

  const initialValues: RegisterStepTwoType = {
    firstName: firstName ? firstName : '',
    lastName: lastName ? lastName : '',
    rut: rut ? rut : '',
  }

  useEffect(() => {
    if (error)
      customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={stepTwoDispatch}
      validationSchema={REGISTER_SCHEMA_STEP_TWO}>
      <VStack w={'full'} maxW={'330px'} spacing={'32px'}>
        <InputControl
          inputProps={{ placeholder: 'Ingresar nombre', maxLength: 50 }}
          name='firstName'
          label='Nombre'
          isDisabled={loading}
        />
        <InputControl
          inputProps={{ placeholder: 'Ingresar apellido', maxLength: 50 }}
          name='lastName'
          label='Apellido'
          isDisabled={loading}
        />
        <InputControl
          inputType='rut'
          inputProps={{ placeholder: '12345678-9', maxLength: 10 }}
          name='rut'
          label='RUT'
          isDisabled={loading}
        />
        <SubmitButton
          w={'full'}
          isLoading={loading}
          loadingText='Validando...'>
          Siguiente
        </SubmitButton>
        <Button
          w={'full'}
          variant={'secondary'}
          onClick={() => prevStep()}>
          Volver
        </Button>
      </VStack>
    </Formik>
  )
}
